module.exports = __webpack_public_path__ + "static/img/document_mismatch.2cf410a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/document_mismatch.svg
// module id = Ykdk
// module chunks = 4